import { useEffect, useState } from "react";
import { INITIAL_FEEDBACK } from "../components/constants";
import { useHistory, useParams } from "react-router-dom";
import { User_Type } from "../components/UserContext";
import { Admin_Service } from "../services/admin/admin-service";
import { Superadmin_Service } from "../services/superadmin/superadmin-service";

export function UseIsUserLogged() {
    const [feedback, set_feedback] = useState({
        ...INITIAL_FEEDBACK,
        loading: true,
    });
    const history = useHistory();
    const params = useParams<{ user_type: User_Type }>();

    async function is_user_logged() {
        console.log(params);

        if (!params.user_type) return;

        const handler =
            params.user_type === User_Type.Admin
                ? Admin_Service.is_logged
                : Superadmin_Service.is_logged;

        const [data, error] = await handler();

        set_feedback((f) => ({ ...f, loading: false }));

        if (error) {
            return;
        }

        if (data?.admin) {
            history.replace(`/${data.admin.user_type ?? params.user_type}/`);
        }
    }

    useEffect(() => {
        is_user_logged();
    }, []);

    return { feedback };
}
